import { render, staticRenderFns } from "./MarketingSiteOptions.vue?vue&type=template&id=397b0a13&scoped=true"
import script from "./MarketingSiteOptions.vue?vue&type=script&lang=js"
export * from "./MarketingSiteOptions.vue?vue&type=script&lang=js"
import style0 from "./MarketingSiteOptions.vue?vue&type=style&index=0&id=397b0a13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397b0a13",
  null
  
)

export default component.exports